
export const getFeedLevelFromTimestamp = (timestamp: number) => {
    const level = Math.floor((new Date().getTime() - timestamp) / 1000 / 60 / 60/24)
    return ((10-level)<0?0:(10-level))
}

export const getLaughLevelFromTimestamp = (timestamp: number) => {
    const level = Math.floor((new Date().getTime() - timestamp) / 1000 / 60 / 60/24)
    return ((5-level)<0?0:(5-level))
}